// Client entry point (architecture §2): loads the styles, finds the ui-flow §1 layers in
// index.html, picks the game server (net/server-url.ts: `?server=` in dev builds only, else the
// build-time VITE_SERVER_URL, else this page's origin) and starts the App.
//
// Implementer: client UI/app.

import './styles/base.css';
import './styles/theme-light.css';
import './styles/theme-dark.css';
import './styles/menu.css';
import './styles/hud.css';
import './styles/onboarding.css';
import './styles/arena.css';
import { App } from './app.js';
import { chooseServerBase } from './net/server-url.js';

function byId<T extends HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`index.html is missing #${id}`);
  return el as T;
}

const app = new App({
  window,
  canvas: byId<HTMLCanvasElement>('game'),
  hudRoot: byId('hud'),
  menuRoot: byId('menu'),
  modalRoot: byId('modal-root'),
  toastRoot: byId('toast-root'),
  serverBase: chooseServerBase({
    envUrl: import.meta.env.VITE_SERVER_URL,
    search: window.location.search,
    // Never in production: the server base receives the player's sign-in tokens.
    allowOverride: import.meta.env.DEV,
  }),
});
app.start();

// Dev convenience: the running app in the console (`ballio.state.get()`, `ballio.store`, …).
if (import.meta.env.DEV) (window as Window & { ballio?: App }).ballio = app;
